import axios from 'axios';

// 創建ops相關api的實體
const opsRequest = axios.create({
    baseURL: '/',
    headers: {
        'Content-Type': 'application/json',
        'Content-Security-Policy': "default-src 'self'; script-src 'self'; style-src 'self'; font-src 'self'; img-src 'self'; frame-src 'self'",
    },
});

const apiKey = {
    'X-API-Key': process.env.VUE_APP_API_KEY,
};

// 包裝ops相關api請求
export function opsPost(url, data, headers) {
    return opsRequest.post(url, data, {
        headers,
    })
    .then(response => response.data)
    .catch((err) => {
        throw err;
    });
}

export function opsGet(url, params, headers) {
    return opsRequest.get(url, {
        params, headers,
    })
    .then(response => response.data)
    .catch((err) => {
        throw err;
    });
}

  export function opsPut(url, data, headers) {
    return opsRequest.put(url, data, {
      headers,
    })
      .then(response => response.data)
      .catch((err) => {
        throw err;
      });
  }

export function opsDelete(url, headers) {
    return opsRequest.delete(url, {
        headers,
    })
    .then(response => response.data)
    .catch((err) => {
        throw err;
    });
}

export function opsPatch(url, data, headers) {
    return opsRequest.patch(url, data, {
        headers,
    })
    .then(response => response.data)
    .catch((err) => {
        throw err;
    });
}

// QRCode取得設備資訊api
// export const deviceInfoApi = data => opsPost('api/activate/verify-url', data, apiKey);
export const deviceInfoApi = data => opsGet(`api/activate/device`, {
    data: data.encodedImei
}, apiKey);

// 納管連結驗證api
export const agreeEnableApi = data => opsPost('api/activate/verify-enable', data, apiKey);

// 輸入開通資料發送簡訊驗證api
export const sendSmsApi = data => opsPost('api/activate/send-otp', data, apiKey);
// export const sendSmsApi = data => opsPost('v1/supplier/sms/send/verify/code', data, apiKey);

// 輸入驗證碼回填簡訊驗證碼api
// export const deviceOpenApi = data => opsPost('v1/supplier/device/open', data, apiKey);
export const deviceOpenApi = data => opsPost('api/activate/device', data, apiKey);

// 簡訊發送納管碼api
export const sendEnabledCodeApi = data => opsPost('api/activate/send-enabledCode', data, apiKey);

// 查詢行程列表api
export const searchScheduleApi = data => opsPost('api/journey/list', data, apiKey);
// export const searchScheduleApi = data => opsPost('v1/supplier/journey/list', data, apiKey);

// 行程路線與點位api
export const scheduleDetailDataApi = data => opsPost('api/journey/path', data, apiKey);
// export const scheduleDetailDataApi = data => opsPost('v1/supplier/journey/path', data, apiKey);

// 行駛報告
export const drivingReportApi = data => opsPost('api/journey/driver-report', data, apiKey);
